import React from 'react';
import { Form, Input, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { doAdminSignIn } from '../modules/auth/stores/thunk';
import { AuthContainer } from '../modules/auth/containers';
import withUnAuth from './withUnAuth';
import LanguageSwitcher from '../components/LanguageSwitcher';

import './AdminSignIn.scss';

const AdminSignInPage = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t } = useTranslation('auth');
  const { t: tc } = useTranslation('common');

  const onLogin = (params) => {
    dispatch(doAdminSignIn(params));
  };

  return (
    <div className="AdminSignInPage">
      <div className="AdminSignInCard">
        <div className="AdminSignInIcon">
          <LockOutlined />
        </div>
        <div className="AdminSignInTitle">{t('adminAccess')}</div>
        <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={onLogin}>
          <Form.Item
            label={tc('email')}
            name="email"
            rules={[
              { type: 'email', message: tc('invalidEmail') },
              { required: true, message: tc('required') },
            ]}
          >
            <Input size="large" placeholder="admin@company.com" />
          </Form.Item>
          <Form.Item label={tc('password')} name="password" rules={[{ required: true, message: tc('required') }]}>
            <Input.Password size="large" placeholder={tc('password')} />
          </Form.Item>
          <Button type="primary" htmlType="submit" block size="large">
            {t('signIn')}
          </Button>
        </Form>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <LanguageSwitcher />
        </div>
      </div>
    </div>
  );
};

export default AuthContainer(withUnAuth(AdminSignInPage));
